import { SGeneralForms, SLocalTreeSelected } from 'shj-components'
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Button, Input, Select, TreeSelect } from 'antd'
import { httpOrgList } from '@/services/homeService.ts'
import { getGeneralList, getProductCommonPage } from '@/services/product.ts'
import { useSetState } from 'ahooks'
import { replaceRule } from '@/utils/data.ts'
import RulesModal from '@/pages/baseProduct/components/RuleModal/RulesModal.tsx'
import dayjs from 'dayjs'
import DebounceSelect from '@/pages/baseProduct/components/DebounceSearchSelect'
import _ from 'lodash'

type IProps = {
  record?: Record<string, any>
  chooseTypeKey?: string
  fn: (data: Record<string, any>) => void
  setLoading: (flag: boolean) => void
}

export const AddOrEditStandard = forwardRef((props: IProps, ref) => {
  const formRef = useRef()

  const [state, setState] = useSetState<any>({
    initValues: {},
    companyList: [],
    budgetRule: '',
    generalList: [],
  })

  const [ruleModal, setRuleModal] = useSetState({
    open: false,
    mode: 'modal',
    value: '',
  })

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  const getOptions = async () => {
    const companyList: any = await httpOrgList()
    const generalList = await getGeneralList({ sonChooseType: 'GEN_STANDARD' })
    setState({ companyList: [{ name: '通用', id: '0' }, ...companyList], generalList })
    shopsControl(['0'], [{ name: '通用', id: '0' }, ...companyList])
    return Promise.resolve({ generalList })
  }

  const getShopArr = codeArr => {
    return [{ id: '0', name: '通用' }, ...state.companyList]?.reduce((res, item) => {
      if (codeArr.includes(item.id)) res.push({ id: item.id, name: item.name })
      return res
    }, [])
  }

  const onFinish = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        props.setLoading?.(true)
        const orgIdList = values.orgIdList ? getShopArr(values.orgIdList) : []
        const values_ = {
          ...values,
          standardJson: { orgIdList: orgIdList, budgetRule: ruleModal.value },
          startDate: values.startDate && dayjs(values.startDate).format('YYYY-MM-DD'),
          endDate: values.endDate && dayjs(values.endDate).format('YYYY-MM-DD'),
          applyProdId: props?.record?.applyProdId ? props.record.applyProdId : null,
        }
        props.fn?.({ ...values_, key: values.key || +new Date() })
        props.setLoading?.(false)
      })
  }

  useImperativeHandle(ref, () => {
    return {
      onFinish,
    }
  }, [onFinish])
  const shopsControl = (value: any, list?: any) => {
    let newOption: any = _.cloneDeep(list || state.companyList)
    if (value?.length) {
      if (value.includes('0')) {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.id !== '0',
          }
        })
      } else {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.id === '0',
          }
        })
      }
    } else {
      newOption = newOption.map((item: any) => {
        return {
          ...item,
          disabled: false,
        }
      })
    }
    setState({
      companyList: newOption,
    })
  }
  return (
    <>
      <SGeneralForms
        ref={formRef}
        isHideGobackBtn={true}
        initialValues={{
          requiredFlag: false,
          editFlag: false,
          applyProdIdList: ['0'],
          orgIdList: ['0'],
        }}
        httpOptionsFn={getOptions}
        layout={'vertical'}
        titleMode={'edit'}
        configs={[
          {
            title: '基础信息',
            formItem: [
              { name: 'id', hidden: true },
              { name: 'key', hidden: true },
              {
                name: 'genItemId',
                label: '选择所属通项',
                required: true,
                rules: [{ required: true, message: '通项不能为空' }],
                spanCol: 24,
                data: 'generalList',
                type: 'select',
                comConfig: {
                  fieldNames: { label: 'itemName', value: 'id' },
                  onChange: (_, o) => setState({ dtlName: o.itemName }),
                },
              },
              {
                name: 'requiredFlag',
                label: '是否必选',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
            ],
          },
          {
            title: '预算量规则',
            formItem: [
              {
                label: '预算量规则',
                spanCol: 24,
                children: (
                  <div>
                    <Button onClick={() => setRuleModal({ open: true })}>编辑规则</Button>
                    {ruleModal?.value && (
                      <Input.TextArea
                        autoSize={{ minRows: 1, maxRows: 4 }}
                        disabled
                        style={{ marginTop: 6 }}
                        value={replaceRule(ruleModal.value)}
                      />
                    )}
                  </div>
                ),
              },
              {
                name: 'editFlag',
                label: '是否可编辑量',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
            ],
          },
          {
            title: '适用渠道',
            titleMode: 'drawer',
            formItem: [
              {
                spanCol: 24,
                label: '适用产品',
                name: 'applyProdIdList',
                required: true,
                rules: [{ required: true, message: '适用产品不能为空' }],
                children: (
                  <DebounceSelect
                    disabled={props.record?.id}
                    allowClear
                    label={'产品'}
                    isCommon={true}
                    mode={'multiple'}
                    fixedParams={{ prodType: 'PRODUCT_PACKAGE' }}
                    fetchOptions={getProductCommonPage}
                    fieldNames={{ label: 'prodName', value: 'id' }}
                    query={{ id: state?.initValues?.applyProdId }}
                  />
                ),
              },
              {
                name: props.record?.id ? 'orgId' : 'orgIdList',
                label: '适用门店',
                spanCol: 24,
                required: true,
                children: (
                  // <SLocalTreeSelected
                  //   treeCheckable
                  //   disabled={props.record?.id}
                  //   treeDefaultExpandAll
                  //   showCheckedStrategy={TreeSelect.SHOW_PARENT}
                  //   fieldNames={{ label: 'name', value: 'id' }}
                  //   treeData={[{ name: '通用', id: '0' }, ...state.companyList]}
                  // />
                  <Select
                    optionFilterProp={'name'}
                    placeholder={'请选择适用门店'}
                    mode={'multiple'}
                    fieldNames={{ label: 'name', value: 'id' }}
                    onChange={(value, option) => {
                      shopsControl(value)
                    }}
                    options={state.companyList}
                    disabled={props.record?.id}
                  />
                ),
              },
              {
                spanCol: 24,
                label: '开始日期',
                name: 'startDate',
                required: true,
                rules: [{ required: true, message: '开始日期不能为空' }],
                type: 'date',
              },
              {
                spanCol: 24,
                label: '结束日期',
                name: 'endDate',
                type: 'date',
                comConfig: {
                  disabledDate: current => {
                    const startDate = onFormRef().getFieldValue('startDate')
                    if (startDate) return current && current < dayjs(startDate).endOf('day')
                  },
                },
              },
            ],
          },
        ]}
      />
      <RulesModal
        modalProps={{ ...ruleModal }}
        onCancel={() => setRuleModal({ open: false })}
        type={'generalBudgetItem'}
        onOk={(value: string) => setRuleModal({ value })}
      />
    </>
  )
})
